import { PromocodeStatus, PromocodePublicationStatus } from '@occc/graphql';
import { StatusChipVariant } from '@occc/ui-design-system';

export const getPromocodeStatusTitle = (status: PromocodeStatus): string =>
  status === PromocodeStatus.Archived ? 'Archived' : 'Active';

export const getPromocodeStatusChipVariant = (status: PromocodeStatus): StatusChipVariant =>
  status === PromocodeStatus.Archived ? 'error' : 'success';

export const titleByPublicationStatus: Record<PromocodePublicationStatus, string> = {
  [PromocodePublicationStatus.Published]: 'Published',
  [PromocodePublicationStatus.NotPublished]: 'Not Published',
  [PromocodePublicationStatus.Expired]: 'Expired',
};

export const chipVariantByPublicationStatus: Record<PromocodePublicationStatus, StatusChipVariant> =
  {
    [PromocodePublicationStatus.Published]: 'success',
    [PromocodePublicationStatus.NotPublished]: 'error',
    [PromocodePublicationStatus.Expired]: 'warning',
  };
